import React from 'react'

const Pageheader = ( {pagename="test",onClick = console.log('back')} ) => {
    return (
        <div>
            <section id="pPageHeader">
                <div className="bHeader">
                    <a className="btnIconBack <?php echo $btnBack; ?>" onClick={onClick}></a>
                    <h1 className="bTitle">{pagename}</h1>
                </div>
            </section>
        </div>
    )
}

export default Pageheader